"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("../helpers/http");
var q_1 = require("../helpers/q");
var params_1 = require("./config/params");
var formConfig_1 = require("./config/formConfig");
var previewConfig_1 = require("./config/previewConfig");
var tabNavConfig_1 = require("./config/tabNavConfig");
var defaults_1 = require("./config/defaults");
var Config = /** @class */ (function () {
    function Config(params, configJson, localeJson, importJson) {
        this.configJson = configJson;
        this.localeJson = localeJson;
        this.importJson = importJson;
        this.versionMatch = true;
        this.params = params;
        // From config.json
        this.forms = new formConfig_1.default(configJson).getForms();
        this.preview = new previewConfig_1.default(configJson).getPreview();
        this.tabs = new tabNavConfig_1.default(configJson).getTabs();
        if (importJson &&
            !this.matchMajorVersion(configJson.version, importJson.version.configVersion)) {
            this.versionMatch = false;
            importJson = null;
        }
        this.defaults = importJson ? importJson.options : new defaults_1.default(this).getDefaults();
        this.uploads = importJson ? importJson.uploads : [];
        // From config.json:
        this.params = Object.assign(this.params, {
            bookId: configJson.id,
            name: configJson.name || configJson.id,
            configName: configJson.configName || configJson.name || configJson.id
        });
    }
    Config.prototype.eachFormOption = function (iterator) {
        var forms = this.forms;
        for (var _i = 0, _a = Object.entries(forms); _i < _a.length; _i++) {
            var _b = _a[_i], groupName = _b[0], group = _b[1];
            for (var _c = 0, _d = Object.entries(group); _c < _d.length; _c++) {
                var _e = _d[_c], id = _e[0], form = _e[1];
                for (var _f = 0, _g = Object.values(form.options); _f < _g.length; _f++) {
                    var option = _g[_f];
                    iterator(option, groupName, id);
                }
            }
        }
        return forms;
    };
    Config.prototype.matchMajorVersion = function (a, b) {
        return a.split('.').shift() === b.split('.').shift();
    };
    return Config;
}());
exports.default = {
    load: function () {
        var params = new params_1.default().getParams();
        var localeJson = http_1.default.get(params.base + "locale/" + params.langUI + "-" + params.langBook + ".json");
        var configJson = http_1.default.get(params.base + "books/" + params.book + "/config/" + params.langUI + "-" + params.langBook + ".json");
        var importJson = params.config ? http_1.default.get("" + params.base + params.config) : undefined;
        return q_1.default.all([configJson, localeJson, importJson])
            .then(function (responses) { return new Config(params, responses[0].data, responses[1].data, responses[2] ? responses[2].data : undefined); }).catch(function () { throw new Error('Failed to load configuration'); });
    }
};
